export const EXPENSE_HEAD_LIST = [
  { label: "HEAD1", value: "head 1" },
  { label: "HEAD2", value: "head 2" },
  { label: "HEAD3", value: "head 3" },
  { label: "HEAD4", value: "head 4" },
];
